import Debug from 'debug';
import _ from 'lodash';
import moment from 'moment-timezone';
const debug = Debug(`knack.core.helpers.date.formatDateRaw`);
const better_regex_civilian_time = new RegExp(/^(0?[1-9]|1[012])[:| ]?([0-5]\d)\s?([a|p]\.?m\.?)$/i);
const better_regex_military_time = new RegExp(/^([01]\d|2[0-3])[:| ]?([0-5]\d)$/);
export const formatDateRaw = (val, format, convert) => {
    debug(`formatDateRaw()`);
    debug(`val:`);
    debug(val);
    debug(`format:`);
    debug(format);
    debug(`convert:`);
    debug(convert);
    // this is done explicitly for values coming from the import controller
    // if this value is a string that contains a date range
    // Example: 03/20/2018 12:45am to 03/21/2018 1:00am
    // then we need to return back to the import controller for processing
    // eventually, we should move that logic from import controller into this helper
    if (_.isString(val) && (val.includes(` to `) || val.includes(` - `))) {
        return ``;
    }
    convert || (convert = false); // what's convert?  do conversion from form inputs, like set repeat dets
    debug(`convert value with logic defaulting it to false applied:`);
    debug(convert);
    let date;
    if (val && val.ignore_convert) {
        convert = false; // used by actions (form rules) to trigger ignore converts
    }
    debug(`convert after considering val.ignore_convert:`);
    debug(convert);
    if (convert && _.isString(val) && moment(val, `YYYY-MM-DDTHH:mm:ssZZ`, true).isValid()) {
        convert = false;
    }
    debug(`convert after considering val.includes(\`T\`) (searching for dates of the format 2009-09-03T00:00:00-07:00 and not converting those for a zapier):`);
    debug(convert);
    let date_format = (convert && format && format.date_format === `dd/mm/yyyy`) ? `DD/MM/YYYY` : `MM/DD/YYYY`;
    let time = 0;
    if (format && format.time_format !== `Ignore Time` && val && !val.all_day) {
        date_format += ` hh:mm a`;
    }
    debug(`date_format: ${date_format}`);
    // We have to consider rejection for 4 different types of inputs: strings, moment objects, date objects,
    // and knack date objects that have hours/minutes/am_pm/etc
    if (format && format.date_format === `Ignore Date` && val &&
        ((_.isString(val) && val.length === 0) ||
            (!moment.isMoment(val) && !(val instanceof Date) && _.isObject(val) && !val.hours && !val.minutes && !val.am_pm) ||
            (moment.isMoment(val) && !val.isValid()))) {
        debug(`RETURN 1`);
        return ``;
    }
    if (!val || ((typeof val.date != `undefined` || typeof val.hours != `undefined`) && !val.hours && !val.date)) {
        debug(`RETURN 2`);
        return ``;
    }
    if (format && format.date_format !== `Ignore Date` && typeof val.date != `undefined` && !val.date) {
        debug(`RETURN 3`);
        return ``;
    }
    const military_time_regex = /^([01]\d|2[0-3])[:| ]?([0-5]\d)$/;
    const civilian_time_regex = /^(0?[1-9]|1[012])[:| ]?([0-5]\d) ([ap][m])$/i;
    // Check if the current field is time only, that val is a string, doesn't already have the expected structure, and passes one of our regexes
    // Then convert to said structure: { hours: 5, minutes: 19, am_pm: 'PM' }.
    // For example, a zapier zap sent us "10:00 AM"
    if (val && !val.all_day && _.isString(val) && format && format.time_format && format.date_format === `Ignore Date` && !val.hours && !val.minutes && !val.am_pm) {
        val = val.trim();
        const should_be_military_time_format = format.time_format.indexOf(`military`) > -1;
        const regex_to_apply = should_be_military_time_format ? military_time_regex : civilian_time_regex;
        debug(`should_be_military_time_format: ${should_be_military_time_format}`);
        if (regex_to_apply.test(val)) {
            const matches = val.match(regex_to_apply);
            if (matches) {
                val = {
                    hours: parseInt(matches[1]),
                    minutes: parseInt(matches[2])
                };
                if (!should_be_military_time_format) { // other code below deals with converting military time to 12-hour format and setting am_pm field
                    val.am_pm = matches[3];
                }
            }
        }
        else {
            debug(`The val provided (${val}) was not in a format that matched our standard corresponding regex: ${regex_to_apply}`);
            debug(`We will now try to parse this with moment then break out the hours, minutes, and meridiem (am/pm) if necessary`);
            // This handles things such as Zapier send us a string val of "2017-08-04T06:00:00-05:00"
            // and currently honors the offset/timezone so the value will be 11:00 AM in this example
            try {
                const parsed_value = moment(val);
                if (!parsed_value) {
                    return ``;
                }
                if (parsed_value.isValid()) {
                    val = {
                        hours: parsed_value.hour(),
                        minutes: parsed_value.minutes()
                    };
                    if (!should_be_military_time_format) { // other code below deals with converting military time to 12-hour format and setting am_pm field
                        val.am_pm = parsed_value.format(`a`);
                    }
                }
            }
            catch (ex) {
                logger.error(ex);
                return ``;
            }
        }
    }
    if (val.date || val.hours) {
        let date_val = (val.date) ? val.date : ``;
        if (val.hours) {
            if (!val.date) {
                val.date = date_val = `01/01/2012`;
            }
            // format to am_pm
            if (format && format.time_format === `HH MM (military)` && !val.am_pm) {
                if (val.hours > 11) {
                    val.am_pm = `pm`;
                    val.hours -= 12;
                }
                else {
                    val.am_pm = `am`;
                }
            }
            const time_val = `${val.hours}:${val.minutes} ${val.am_pm}`;
            date_val = (date_val) ? `${date_val} ${time_val}` : time_val;
            const isMidnight = Number(val.hours) === 12 && val.am_pm.toLowerCase() === `am`;
            let hours = 0;
            if (!isMidnight) {
                hours = Number(val.hours);
                const isPastNoon = val.am_pm.toLowerCase() === `pm`;
                if (isPastNoon) {
                    hours += 12;
                }
            }
            time = hours * 60;
            time += Number(val.minutes);
        }
        try {
            // convert date format to accomodate double digit years
            const date_parts = date_val.split(` `)[0].split(`/`);
            if (date_parts[2] && date_parts[2].length < 4) {
                date_format = date_format.replace(`YYYY`, `YY`);
            }
            date = moment(date_val, date_format);
        }
        catch (err) {
            logger.error(err);
            return ``;
        }
    }
    else {
        debug(`LAST DITCH formatting`);
        // This specifically handles attempting to parse time-only strings regardless if the field is ignoring date as long as the field is NOT ignoring time
        // This is considered a last-resort-effort to parse vals such as "7:00pm" (we've had complaints from zapier about this)
        if (format && format.time_format !== `Ignore Time` && _.isString(val)) {
            val = val.trim();
            const should_be_military_time_format = format.time_format && format.time_format.indexOf(`military`) > -1;
            const regex_to_apply = should_be_military_time_format ? better_regex_military_time : better_regex_civilian_time;
            debug(`should_be_military_time_format: ${should_be_military_time_format}`);
            if (regex_to_apply.test(val)) {
                const matches = val.match(regex_to_apply);
                /* eslint-disable max-depth */
                if (matches) {
                    if (should_be_military_time_format) {
                        date = moment().utc().startOf(`day`).add(matches[1], `hours`).add(matches[2], `minutes`);
                    }
                    else {
                        let civilian_hours = _.isNil(matches[1]) ? 0 : Number(matches[1]);
                        debug(`civilian_hours is starting out as: ${civilian_hours}`);
                        // The 12th hour represents midnight (AM) or noon (PM)
                        // so we have to handle those according to whether or not the data value is representing AM or PM
                        if (matches[3].includes(`a`)) {
                            debug(`we are dealing with AM meridiem so we need to check if civilian_hours is 12, if so, set civilian_hours to 0`);
                            // 12 is representative of 12:xx AM, we do not want to add any hours so we set it to 0 so no hours are added
                            if (civilian_hours === 12) {
                                debug(`civilian_hours is 12, setting to 0!`);
                                civilian_hours = 0;
                            }
                        }
                        else { // assume this indicates PM
                            debug(`we are dealing with PM meridiem so we need to check if civilian_hours is NOT 12, if so, add 12 to civilian_hours`);
                            // Anything except 12 needs an additional 12 hours added to it so that moment can take the military version and automagically format
                            // it back to civilian for us (e.g., 1:00pm = 13:00)
                            if (civilian_hours !== 12) {
                                debug(`civilian_hours is NOT 12, adding 12 hours to force PM!`);
                                civilian_hours = civilian_hours + 12;
                            }
                        }
                        date = moment().utc().startOf(`day`).add(civilian_hours, `hours`).add(matches[2], `minutes`);
                    }
                }
                /* eslint-enable max-depth */
            }
            else {
                date = moment(val, date_format);
                if (!date.isValid()) {
                    date = moment(val);
                }
            }
        }
        else {
            debug(`LAST DITCH INNER ELSE`);
            debug(`val is currently:`);
            debug(val);
            date = moment(val, date_format);
            debug(`date is valid now? ${date.isValid()}`);
            // Zapier sometimes sends us values like "2018-03-09T05:00:00.000Z" that doesn't match any of our usual format expectations
            // so we will see if moment can handle things for us
            if (!date.isValid()) {
                debug(`date wasn't valid with attempted date_format so let's see if we can just use the value blindly`);
                date = moment(val);
                debug(`date is valid now after blind format? ${date.isValid()}`);
            }
        }
    }
    // Not really sure why this conditional is necessary but it has something to do with
    // the initially decl of date_format taking convert argument into consider yet we ignore it here
    // API record POSTs seemed to work without this block but I'm afraid other avenues may rely on it (rules, calendar stuff?, etc?)
    if (!_.isNil(format)) {
        switch (format.date_format) {
            case `dd/mm/yyyy`:
                date_format = `DD/MM/YYYY`;
                break;
            default:
                date_format = `MM/DD/YYYY`;
                break;
        }
    }
    const raw = {
        date: date.format(`MM/DD/YYYY`),
        date_formatted: date.format(date_format),
        hours: date.format(`hh`),
        minutes: date.format(`mm`),
        am_pm: date.format(`A`),
        unix_timestamp: date.valueOf(),
        iso_timestamp: date.toISOString(),
        timestamp: date.format(`MM/DD/YYYY hh:mm a`),
        time
    };
    if (val.to_date) {
        raw.to = this.formatDateRaw({
            date: val.to_date,
            hours: val.to_hours,
            minutes: val.to_minutes,
            am_pm: val.to_am_pm
        }, format, convert);
    }
    else if (val.to) {
        raw.to = this.formatDateRaw({
            date: val.to.date,
            hours: val.to.hours,
            minutes: val.to.minutes,
            am_pm: val.to.am_pm,
            all_day: val.all_day
        }, format, convert);
    }
    if (val.repeat) {
        raw.repeat = val.repeat;
        if (convert) {
            raw.repeat.start_date = raw.date;
            // set end date
            if (raw.repeat.endson === `limit`) {
                // This uses 'MM/DD/YYYY' because it's forced in raw above, changing it there breaks other tests
                var end_date = moment(raw.date, `MM/DD/YYYY`);
                let which;
                switch (raw.repeat.frequency) {
                    case `daily`:
                        which = `days`;
                        break;
                    case `weekly`:
                        which = `weeks`;
                        break;
                    case `monthly`:
                        which = `months`;
                        break;
                    case `yearly`:
                        which = `days`;
                        break;
                }
                end_date.add((raw.repeat.interval * (raw.repeat.end_count - 1)), which);
                // add 7 days for month so it doesn't matter which day it falls on
                if (which === `months`) {
                    end_date.add(7, `days`);
                }
                raw.repeat.end_date = end_date.format(date_format);
            }
            else if (raw.repeat.endson === `date`) {
                raw.repeat.end_date = moment(raw.repeat.end_date, date_format).format(date_format);
            }
            raw.repeat.start_date = raw.date;
            // set end date
            if (raw.repeat.end_date && end_date) {
                // set to timestamp for mongo queries
                raw.repeat.end_timestamp = end_date.valueOf();
            }
        }
    }
    // calendar vars
    if (val.all_day) {
        raw.all_day = val.all_day;
        if (raw.to) {
            raw.to.all_day = val.all_day;
        }
    }
    if (moment(new Date(raw.date))._d !== `Invalid Date`) {
        debug(`We have a valid moment object, returning raw:`);
        debug(raw);
        return raw;
    }
    debug(`returning blank like a sad panda because we could not figure out how to format this value or it was just totally invalid`);
    return ``;
};
